import React,{ useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Logo } from './screens/Logo';
import { Video } from './screens/Video';
import { AuctionName } from './screens/AuctionName';
import { CurrentHorse } from './screens/CurrentHorse';
import { ColCenter } from './controls/ColCenter';
import axios from 'axios';
import { CurrentHorseSlideshow } from './screens/CurrentHorseSlideshow';
import { PreviousHorse } from './screens/PreviousHorse';
import { NextHorse } from './screens/NextHorse';
import { Top3 } from './screens/Top3';
import { AvgPrice } from './screens/AvgPrice';

export const Home = () => {
  const [data, setdata] = useState([]);

  useEffect(() => {
    getData();
    setInterval(() => getData(), 5000);
  }, []);

  function getData() {
      axios.get(`https://menhammaronlinesales.se/wp-json/menhammaronlinesales/v1/live-auction-stats`)
      //axios.get(`https://auction-staging.menhammaronlinesales.se/wp-json/menhammaronlinesales/v1/live-auction-stats`)
        .then(res => {
            setdata(res.data);
        })
        .catch(error => {
            console.log(error);
        });
  }

    return (
      <Container fluid={true}>
        <Row>
          <ColCenter>
            <AuctionName data={data}/>
          </ColCenter>
          <ColCenter>
            <Video data={data}/>
          </ColCenter>
          <ColCenter>
            <Logo/>
          </ColCenter>
        </Row>
        <Row>
          <ColCenter>
            <CurrentHorse data={data}/>
          </ColCenter>
          <Col>
            <CurrentHorseSlideshow data={data}/>
          </Col>
          <ColCenter>
            <PreviousHorse data={data}/>
          </ColCenter>
        </Row>
        <Row>
          <ColCenter>
            <NextHorse data={data}/>
          </ColCenter>
          <ColCenter>
            <Top3 data={data}/>
          </ColCenter>
          <ColCenter>
            <AvgPrice data={data}/>
          </ColCenter>
        </Row>
      </Container>
    );
}
